<template>
    <div class="modal fade" ref="modal" role="dialog" aria-labelledby="aboutBoxTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title" id="aboutBoxTitle">
                        About ExtendWeather Online
                    </div>                    
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <p class="text-center">Version: {{ version }}</p>
                        <p class="text-center">Last software update: {{ versionDate }}</p>
                        <p class="text-center">Copyright (C) CLIMsystems Ltd</p>
                        <p class="text-center">
                            <a href="https://www.extendweather.com" target="_blank">https://www.extendweather.com</a><br/>
                            <a href="https://www.climsystems.com" target="_blank">https://www.climsystems.com</a>
                        </p>
                        <hr/>
                        <div class="change-log">
                            <h5>Version 1.3</h5>
                            <ul>
                                <li>Added 'Save' button in Chart chart panel (charts can be saved as PNG's)</li>
                                <li>By default, the historical value popup now displays data for the same set of months as available for the selected forecast</li>
                                <li>Added an option in the Settings dialog to display all values for historical popup</li>
                            </ul>

                            <h5>Version 1.2</h5>
                            <ul>
                                <li>Latest forecast is auto selected by default in Select Forecast dialog</li>
                                <li>Added a link to show/hide the legend</li>
                                <li>Zoom controls moved to bottom/right of map</li>
                                <li>Minor visual improvements</li>
                            </ul>
                            
                            <h5>Version 1.1</h5>
                            <ul>
                                <li>Clicking a location on the map now shows values popup (with Save button) instead of Add Point dialog</li>
                                <li>Clicking Data Layer points (such as RWC overlay for Japan) now shows values at location, not just the location/point name</li>
                            </ul>

                            <h5>Version 1.0.1</h5>
                            <ul>
                                <li>Released: 30/09/2019</li>
                                <li>Added Summary tool (accessable via the toolbar)</li>
                                <li>UX improvements</li>
                            </ul>

                            <h5>Version 1.0</h5>
                            <ul>
                                <li>Released: 23/09/2019</li>
                                <li>ExtendWeather Online is now out of beta</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>                
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import $ from '@/lib/JQuery.js'
import config from '@/lib/config.js'

export default {
    name: 'AboutBoxDialog',
    data() {
        return {
            version: '...',
            versionDate: '...'
        }
    },
    methods: {
        open() {
            $(this.$refs.modal).modal('show')
        }
    },
    mounted() {
        this.version = config.version
        this.versionDate = config.versionDate
    }
}
</script>

<style>
.change-log {
    text-align: left;
    position: relative;
    max-height: 150px;
    overflow: hidden;
    overflow-y: auto;
    border: 1px solid rgb(230, 230, 230);
    padding: 1em;
}

.change-log h5 {
    font-size: 12pt;
}
</style>